module.exports = __webpack_public_path__ + "img/add_row_after.c3fc03a2.svg";